import SelectLocation from "./pages/SelectLocation";
import SelectSchool from "./pages/SelectSchool";
import SelectTeam from "./pages/SelectTeam";
import Order from "./pages/Order";
import Checkout from "./pages/Checkout";
import CheckoutCashCheck from "./pages/CheckoutCashCheck";
import TicketRedemption from "./pages/TicketRedemption";
import Fundraiser from "./pages/Fundraiser";
import FundraiserOrders from "./pages/FundraiserOrders";
import Fundraisers from "./pages/Fundraisers";
import UserOffers from "./pages/UserOffers";
import UserDiscountManager from "./pages/UserDiscountManager";
import UserTeam from "./pages/UserTeam";
import UserTicket from "./pages/UserTicket";
import UserRequestLink from "./pages/UserRequestLink";
import UserRequestLinkConfirmation from "./pages/UserRequestLinkConfirmation";
import UserLinkRedemption from "./pages/UserLinkRedemption";
import Help from "./pages/Help";
import Receipt from "./pages/Receipt";
import Donations from "./pages/Donations";

const AppRoutes = [
    {
        index: true,
        element: <SelectLocation />
    },
    {
        path: '/SelectLocation',
        element: <SelectLocation />
    },
    {
        path: '/Give',
        element: <SelectLocation product={"give"} />
    },
    {
        path: '/Donate',
        element: <SelectLocation product={"donate"} />
    },
    {
        path: '/Help',
        element: <Help />
    },
    {
        path: '/Purchase/:pItemId/:pPhone',
        element: <SelectLocation />
    },
    {
        path: '/SelectSchool/:location/:itemId/:phone',
        element: <SelectSchool />
    },
    {
        path: '/SelectTeam/:schoolId/:itemId/:phone',
        element: <SelectTeam />
    },
    {
        path: '/Order/:fundraiserId/:itemId/:phone',
        element: <Order />
    }
    ,
    {
        path: '/Order/:fdid',
        element: <Order />
    },
    {
        path: '/Order/:fdid/:cashcheck',
        element: <Order />
    },
    {
        path: '/Order/Edit/:orderId',
        element: <Order />
    },
    {
        path: '/Order/Contact/:contactGuid',
        element: <Order />
    },
    {
        path: '/Order/Social/:socialGuid',
        element: <Order />
    },

    {
        path: '/Fundraisers/:fdid',
        element: <Fundraisers />
    },
    {
        path: '/FundraiserOrders/:fdid',
        element: <FundraiserOrders />
    },
    {
        path: '/Fundraiser/:fundraiserDeviceGuid',
        element: <Fundraiser />
    },
    {
        path: '/Checkout/:orderId',
        element: <Checkout />
    },
    {
        path: '/CheckoutCashCheck/:orderId/:cashcheck',
        element: <CheckoutCashCheck />
    },
    {
        path: '/MyOffers/:ticketPurchaseSessionGuid',
        element: <UserOffers />
    },
    {
        path: '/ReactivateTicket/:ticketPurchaseSessionGuid',
        element: <UserRequestLink />
    },
    {
        path: '/ActivateTicket/:ticketPurchaseSessionGuid',
        element: <UserRequestLink />
    },
    {
        path: '/ActivateTicket/:ticketPurchaseSessionGuid/Confirmation/:phoneNumber',
        element: <UserRequestLinkConfirmation />
    },
    {
        path: '/ActivateTicket/:ticketPurchaseSessionGuid/Confirmation/',
        element: <UserRequestLinkConfirmation />
    },
    {
        path: '/ActivateTicket/:ticketPurchaseSessionGuid/RegisterDevice/:phoneNumber',
        element: <UserLinkRedemption />
    },
    {
        path: '/ActivateTicket/:ticketPurchaseSessionGuid/RegisterDevice/',
        element: <UserLinkRedemption />
    },
    {
        path: '/MyTicket/:ticketPurchaseSessionGuid',
        element: <UserTicket />
    },
    {
        path: '/MyTeam/:ticketPurchaseSessionGuid',
        element: <UserTeam />
    },
    {
        path: '/ManageDiscounts/:ticketPurchaseGuid',
        element: <UserDiscountManager />
    },

    {
        path: '/MyOffers/:ticketPurchaseSessionGuid/Redeem/:ticketOfferId',
        element: <TicketRedemption />
    },
    {
        path: '/TicketPreview/:fundraiserId/',
        element: <UserOffers />
    },
    {
        path: '/Receipt/:orderId/:signature',
        element: <Receipt />
    },
    {
        path: '/donations/:fundraiserId',
        element: <Donations />
    }
];

export default AppRoutes;
